// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7e415565","885":"602076aa"}[chunkId] + ".chunk.js";
};